"use client";

import type { SessionCountdown } from "@/hooks/useSessionCountdown";
import { Countdown } from "./Countdown";
import { CalendarLinks } from "./CalendarLinks";
import { WhatsappCta } from "./WhatsappCta";
import { MC_JOIN_URL } from "@/lib/config";
import { HORS_CIBLE } from "@/lib/masterclass";

// ============================================================================
// /mc/hc — profil hors cible pour l'offre, mais bienvenu à la session.
//   On donne le lien comme à tout le monde. La seule différence est invisible
//   pour le visiteur : cette route est dans AD_MUTED_PATHS, donc ni le Pixel
//   Meta ni la CAPI ni Google Ads ne sont sollicités ici (cf. @/lib/ad-tracking).
//   Sortie sans reproche : la charte de marque interdit la culpabilisation, et
//   un refus sec ferme la porte à un futur format.
// ============================================================================

export function MasterclassHorsCible({
  firstName,
  countdown,
  whatsapp,
  onWhatsapp,
}: {
  firstName?: string;
  countdown: SessionCountdown;
  whatsapp: boolean;
  onWhatsapp?: (location: string) => void;
}) {
  const prenom = firstName?.trim();

  return (
    <div className="mx-auto w-full max-w-xl text-center">
      <span className="mb-5 inline-flex items-center rounded-full border border-brand/30 bg-brand/10 px-3 py-1 text-xs font-medium text-brand">
        {HORS_CIBLE.badge}
      </span>

      <h1 className="text-balance text-2xl font-extrabold sm:text-3xl">
        {prenom ? `${prenom}, ${HORS_CIBLE.title.toLowerCase()}` : HORS_CIBLE.title}
      </h1>

      <div className="mx-auto mt-4 space-y-3 text-pretty text-[15px] leading-relaxed text-ink/70">
        {HORS_CIBLE.body.map((p) => (
          <p key={p}>{p}</p>
        ))}
      </div>

      <Countdown c={countdown} className="mt-8" />

      <CalendarLinks countdown={countdown} className="mt-8" />

      {whatsapp && <WhatsappCta className="mt-8 text-center" onClick={() => onWhatsapp?.("hc")} />}

      {MC_JOIN_URL && (
        <p className="mt-6 text-sm text-ink/70">
          Le jour J, rejoignez le direct ici :{" "}
          <a
            href={MC_JOIN_URL}
            className="font-semibold text-brand underline underline-offset-2"
          >
            {MC_JOIN_URL}
          </a>
        </p>
      )}

      <p className="mt-8 text-xs text-ink/45">{HORS_CIBLE.reminder}</p>

      <a
        href="/mc"
        className="mt-10 inline-block text-sm text-ink/45 underline underline-offset-2 transition hover:text-ink"
      >
        ← Revenir à la page de la masterclass
      </a>

    </div>
  );
}
